import React from 'react'
import "./Copyright.css"

function Copyright() {
  return (
    <div  className='copy'>
       <p><i className='bx bx-copyright'></i>DarkCof 2023</p>
    </div>
  )
}

export default Copyright
